import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  formRoot: {
    display: 'flex',
    overflow: 'scroll',
    flexDirection: 'column',
    height: '100%',
  },

  stepsHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: zeplinColor.Neutral1,
  },

  stepContent: { padding: '24px', height: '100%', overflow: 'scroll' },

  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    width: 'calc(100% - 209px)',
    bottom: '0px',
    padding: '24px',
    boxShadow: '0 -2px 10px #00000012',
  },

  cancelButton: {
    borderRadius: '14px',
    width: '108px',
    border: `1px solid ${zeplinColor.BasicBlack}`,
    '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
    color: zeplinColor.BasicBlack,
  },

  navigationControls: {
    display: 'inline-flex',
    gap: '24px',
    justifyContent: 'space-between',
  },

  previousButton: {
    borderRadius: '14px',
    width: '108px',
    border: `1px solid ${zeplinColor.BasicBlack}`,
    color: zeplinColor.BasicBlack,

    '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
    '&.Mui-disabled': {
      backgroundColor: zeplinColor.Neutral5,
      color: zeplinColor.BasicBlack,
    },
  },

  actionButton: {
    borderRadius: '14px',
    width: '108px',
    '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
  },
};
